import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ResetParticipant } from '../../../../utilities/DL/PersonalSurfer';

/**
 * MODAL: PersonalSurferResetModal
 * Permite al operador reiniciar el intento de un aficionado ("Dar otra oportunidad").
 */
export const PersonalSurferResetModal = ({
    isOpen,
    onClose,
    participant = null,
    roomId,
    onSuccess = () => {},
    triggerToast = () => {}
}) => {
    const [isResetting, setIsResetting] = useState(false);

    if (!isOpen || !participant) return null;

    const handleConfirm = async () => {
        setIsResetting(true);
        try {
            const res = await ResetParticipant(participant.id, roomId);
            if (res.success) {
                triggerToast('success', `Intento reiniciado para ${participant.fullName || 'el aficionado'}.`);
                onSuccess();
                onClose();
            } else {
                triggerToast('error', res.message || 'Error al reiniciar intento.');
            }
        } catch (err) {
            triggerToast('error', 'Error al ejecutar la acción.');
        } finally {
            setIsResetting(false);
        }
    };

    return (
        <div className="ps-modal-overlay">
            <div className="ps-modal-container ps-confirm-modal">
                <div className="ps-modal-header">
                    <h3>
                        <i className="bi bi-arrow-counterclockwise me-2 text-warning" />
                        Dar Otra Oportunidad
                    </h3>
                    <button type="button" className="ps-close-btn" onClick={onClose}>
                        <i className="bi bi-x-lg" />
                    </button>
                </div>

                <div className="ps-modal-body">
                    <p className="mb-3">
                        ¿Estás seguro de que deseas otorgar un nuevo intento a{' '}
                        <strong className="text-info">{participant.fullName || 'este aficionado'}</strong>?
                    </p>
                    <div className="ps-alert-info">
                        <i className="bi bi-info-circle-fill me-2" />
                        Se emitirá un nuevo token OTT que le permitirá reiniciar la carrera en su móvil. Su puntaje anterior ({participant.score || 0} pts) será archivado para auditoría.
                    </div>
                </div>

                <div className="ps-modal-footer">
                    <button type="button" className="ps-btn ps-btn-secondary" onClick={onClose} disabled={isResetting}>
                        Cancelar
                    </button>
                    <button type="button" className="ps-btn ps-btn-warning" onClick={handleConfirm} disabled={isResetting}>
                        <i className="bi bi-arrow-clockwise me-1" />
                        {isResetting ? 'Reiniciando...' : 'Confirmar Reintento'}
                    </button>
                </div>
            </div>
        </div>
    );
};

PersonalSurferResetModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    participant: PropTypes.object,
    roomId: PropTypes.string,
    onSuccess: PropTypes.func,
    triggerToast: PropTypes.func
};
